"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsApi = void 0;
var runtime = __importStar(require("../runtime"));
var CheckoutSubscriptionDto_1 = require("../models/CheckoutSubscriptionDto");
var ReorderSportsDto_1 = require("../models/ReorderSportsDto");
var SubscriptionsControllerGetAccessibleSportsV1200Response_1 = require("../models/SubscriptionsControllerGetAccessibleSportsV1200Response");
var SubscriptionsControllerGetMyFeaturesV1200Response_1 = require("../models/SubscriptionsControllerGetMyFeaturesV1200Response");
var SubscriptionsControllerGetMySubscriptionV1200Response_1 = require("../models/SubscriptionsControllerGetMySubscriptionV1200Response");
var SubscriptionsControllerGetPaymentHistoryV1200Response_1 = require("../models/SubscriptionsControllerGetPaymentHistoryV1200Response");
var SubscriptionsControllerListPlansV1200Response_1 = require("../models/SubscriptionsControllerListPlansV1200Response");
var SubscriptionsControllerSwapSportV1200Response_1 = require("../models/SubscriptionsControllerSwapSportV1200Response");
var SwapSportDto_1 = require("../models/SwapSportDto");
/**
 *
 */
var SubscriptionsApi = /** @class */ (function (_super) {
    __extends(SubscriptionsApi, _super);
    function SubscriptionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates request options for subscriptionsControllerCancelV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerCancelV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/cancel";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * **Backend-owned Champion only** (trial, referral, promotional). Store-billed rows (`APP_STORE` / `PLAY_STORE` / `MAC_APP_STORE` / Test Store `UNKNOWN`, or `provider=revenuecat` that is not `PROMOTIONAL`) are rejected — cancel in Apple or Google settings.  **Paid time remaining:** records cancel intent (`status=cancelled`, `autoRenew=false`), schedules downgrade to free at `expires_at`, and preserves current plan access until then.  **No paid time remaining:** backend-owned subs downgrade to free immediately; RC subs rely on sync/expiry.
     * Cancel subscription
     */
    SubscriptionsApi.prototype.subscriptionsControllerCancelV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerCancelV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetMySubscriptionV1200Response_1.SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * **Backend-owned Champion only** (trial, referral, promotional). Store-billed rows (`APP_STORE` / `PLAY_STORE` / `MAC_APP_STORE` / Test Store `UNKNOWN`, or `provider=revenuecat` that is not `PROMOTIONAL`) are rejected — cancel in Apple or Google settings.  **Paid time remaining:** records cancel intent (`status=cancelled`, `autoRenew=false`), schedules downgrade to free at `expires_at`, and preserves current plan access until then.  **No paid time remaining:** backend-owned subs downgrade to free immediately; RC subs rely on sync/expiry.
     * Cancel subscription
     */
    SubscriptionsApi.prototype.subscriptionsControllerCancelV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerCancelV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerCheckoutV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerCheckoutV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['checkoutSubscriptionDto'] == null) {
                            throw new runtime.RequiredError('checkoutSubscriptionDto', 'Required parameter "checkoutSubscriptionDto" was null or undefined when calling subscriptionsControllerCheckoutV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/checkout";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, CheckoutSubscriptionDto_1.CheckoutSubscriptionDtoToJSON)(requestParameters['checkoutSubscriptionDto']),
                            }];
                }
            });
        });
    };
    /**
     * **Dev / mock billing endpoint.** In production on iOS/Android, purchases go through the RC SDK on-device; mobile should NOT call this for RC-owned subs.  **Behavior branches:** - Same-plan re-checkout → clears any scheduled downgrade (implicit \"keep my plan\"), no charge. - Upgrade / new plan → charges via `BillingProvider`, writes payment + updates sub row. - Only `champion_yearly` is accepted. `pro_yearly` is rejected.
     * Checkout / change plan (backend-owned flows only)
     */
    SubscriptionsApi.prototype.subscriptionsControllerCheckoutV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerCheckoutV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetMySubscriptionV1200Response_1.SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * **Dev / mock billing endpoint.** In production on iOS/Android, purchases go through the RC SDK on-device; mobile should NOT call this for RC-owned subs.  **Behavior branches:** - Same-plan re-checkout → clears any scheduled downgrade (implicit \"keep my plan\"), no charge. - Upgrade / new plan → charges via `BillingProvider`, writes payment + updates sub row. - Only `champion_yearly` is accepted. `pro_yearly` is rejected.
     * Checkout / change plan (backend-owned flows only)
     */
    SubscriptionsApi.prototype.subscriptionsControllerCheckoutV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerCheckoutV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerConfirmV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerConfirmV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['checkoutSubscriptionDto'] == null) {
                            throw new runtime.RequiredError('checkoutSubscriptionDto', 'Required parameter "checkoutSubscriptionDto" was null or undefined when calling subscriptionsControllerConfirmV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/confirm";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, CheckoutSubscriptionDto_1.CheckoutSubscriptionDtoToJSON)(requestParameters['checkoutSubscriptionDto']),
                            }];
                }
            });
        });
    };
    /**
     * Mobile calls this immediately after `Purchases.purchasePackage()` succeeds on the RC SDK. Backend force-syncs from RC and returns the refreshed subscription.  **202 semantics:** if RC has not yet propagated the transaction (common for the first few seconds after purchase), returns `202 Accepted` with `pending=true` in `data`. Mobile should retry with backoff (~1s, 3s, 7s).
     * Confirm an on-device purchase (nudges backend sync)
     */
    SubscriptionsApi.prototype.subscriptionsControllerConfirmV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerConfirmV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetMySubscriptionV1200Response_1.SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mobile calls this immediately after `Purchases.purchasePackage()` succeeds on the RC SDK. Backend force-syncs from RC and returns the refreshed subscription.  **202 semantics:** if RC has not yet propagated the transaction (common for the first few seconds after purchase), returns `202 Accepted` with `pending=true` in `data`. Mobile should retry with backoff (~1s, 3s, 7s).
     * Confirm an on-device purchase (nudges backend sync)
     */
    SubscriptionsApi.prototype.subscriptionsControllerConfirmV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerConfirmV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerGetAccessibleSportsV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetAccessibleSportsV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/me/sports";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Returns the codes the user is allowed to follow, plus `reorderSports` for the \"manage digest\" swap sheet ordering.
     * Sports accessible on my current plan
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetAccessibleSportsV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerGetAccessibleSportsV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetAccessibleSportsV1200Response_1.SubscriptionsControllerGetAccessibleSportsV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the codes the user is allowed to follow, plus `reorderSports` for the \"manage digest\" swap sheet ordering.
     * Sports accessible on my current plan
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetAccessibleSportsV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerGetAccessibleSportsV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerGetMyFeaturesV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetMyFeaturesV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/me/features";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Ready-to-render matrix of every visible feature (`favorites_retention_days`, `missed_list_days`, `evening_digest_enabled`, `notification_windows`, etc.) with the value applicable to this user. Mobile uses this to lock/unlock UI without shipping the pricing rules.
     * Feature matrix for my current plan (mobile UI gating)
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetMyFeaturesV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerGetMyFeaturesV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetMyFeaturesV1200Response_1.SubscriptionsControllerGetMyFeaturesV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Ready-to-render matrix of every visible feature (`favorites_retention_days`, `missed_list_days`, `evening_digest_enabled`, `notification_windows`, etc.) with the value applicable to this user. Mobile uses this to lock/unlock UI without shipping the pricing rules.
     * Feature matrix for my current plan (mobile UI gating)
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetMyFeaturesV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerGetMyFeaturesV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerGetMySubscriptionV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetMySubscriptionV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/me";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Backend view (DB-authoritative). For an RC-owned sub, call `POST /sync` first if the client suspects staleness.
     * Get my current subscription
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetMySubscriptionV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerGetMySubscriptionV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetMySubscriptionV1200Response_1.SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Backend view (DB-authoritative). For an RC-owned sub, call `POST /sync` first if the client suspects staleness.
     * Get my current subscription
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetMySubscriptionV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerGetMySubscriptionV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerGetPaymentHistoryV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetPaymentHistoryV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/me/payments";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Chronological list of `payments` rows from RC webhooks (INITIAL_PURCHASE, RENEWAL, REFUND) and from `/confirm` `/sync` `/restore` when the webhook never wrote the charge. Refunds appear as separate rows with `status=\"refunded\"` — the ledger keeps a full trail.
     * Payment history (charges + refunds)
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetPaymentHistoryV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerGetPaymentHistoryV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetPaymentHistoryV1200Response_1.SubscriptionsControllerGetPaymentHistoryV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Chronological list of `payments` rows from RC webhooks (INITIAL_PURCHASE, RENEWAL, REFUND) and from `/confirm` `/sync` `/restore` when the webhook never wrote the charge. Refunds appear as separate rows with `status=\"refunded\"` — the ledger keeps a full trail.
     * Payment history (charges + refunds)
     */
    SubscriptionsApi.prototype.subscriptionsControllerGetPaymentHistoryV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerGetPaymentHistoryV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerListPlansV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerListPlansV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['countryId'] != null) {
                            queryParameters['countryId'] = requestParameters['countryId'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/plans";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Renders the plan sheet. When `countryId` is provided, each item contains localized `price`; otherwise INR is used. `launchPromo` carries the catalog fallback amount (₹299). The charged price comes from the store. Public — no auth required.
     * List active subscription plans (public catalog)
     */
    SubscriptionsApi.prototype.subscriptionsControllerListPlansV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerListPlansV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerListPlansV1200Response_1.SubscriptionsControllerListPlansV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Renders the plan sheet. When `countryId` is provided, each item contains localized `price`; otherwise INR is used. `launchPromo` carries the catalog fallback amount (₹299). The charged price comes from the store. Public — no auth required.
     * List active subscription plans (public catalog)
     */
    SubscriptionsApi.prototype.subscriptionsControllerListPlansV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerListPlansV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerReorderSportsV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerReorderSportsV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['reorderSportsDto'] == null) {
                            throw new runtime.RequiredError('reorderSportsDto', 'Required parameter "reorderSportsDto" was null or undefined when calling subscriptionsControllerReorderSportsV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/me/sports/order";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, ReorderSportsDto_1.ReorderSportsDtoToJSON)(requestParameters['reorderSportsDto']),
                            }];
                }
            });
        });
    };
    /**
     * Persists the drag-order the user picks in the manage-digest reorder sheet.  **Reorder vs swap:** for Free, replacing a selected sport with a new one consumes a swap (complimentary first, then 1 / rolling 365 days). Pure reorder and filling an empty slot are free.  **Champion / trial** must include all selected sports exactly once. **Free** persists at most 2 sports.
     * Reorder followed sports (manage-digest sheet)
     */
    SubscriptionsApi.prototype.subscriptionsControllerReorderSportsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerReorderSportsV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerSwapSportV1200Response_1.SubscriptionsControllerSwapSportV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Persists the drag-order the user picks in the manage-digest reorder sheet.  **Reorder vs swap:** for Free, replacing a selected sport with a new one consumes a swap (complimentary first, then 1 / rolling 365 days). Pure reorder and filling an empty slot are free.  **Champion / trial** must include all selected sports exactly once. **Free** persists at most 2 sports.
     * Reorder followed sports (manage-digest sheet)
     */
    SubscriptionsApi.prototype.subscriptionsControllerReorderSportsV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerReorderSportsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerRestoreV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerRestoreV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/restore";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Same effect as `/sync` — kept separate for cleaner client semantics and a distinct log metric (`metric=subscription.restore`). Mobile should call this after `Purchases.restorePurchases()` on the RC SDK completes. Also backfills payment history when the original webhook never wrote the charge.
     * Restore purchases (after reinstall / new-device signin)
     */
    SubscriptionsApi.prototype.subscriptionsControllerRestoreV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerRestoreV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetMySubscriptionV1200Response_1.SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Same effect as `/sync` — kept separate for cleaner client semantics and a distinct log metric (`metric=subscription.restore`). Mobile should call this after `Purchases.restorePurchases()` on the RC SDK completes. Also backfills payment history when the original webhook never wrote the charge.
     * Restore purchases (after reinstall / new-device signin)
     */
    SubscriptionsApi.prototype.subscriptionsControllerRestoreV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerRestoreV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerStartFreeTrialV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerStartFreeTrialV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/start-free-trial";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Grants a **10-day free trial** on the plan sheet — backend-only (no RC involvement, no card required).  **One-time enforcement:** the trial can only be started by users where `users.free_trial_used_at IS NULL` **and** `users.paid_purchase_ever_at IS NULL`. Anyone who has ever taken the trial OR paid for any plan is rejected.  Idempotent for an already-active trial — repeated calls while `status=\"trialing\"` return the current state.
     * Start the one-time 10-day free trial
     */
    SubscriptionsApi.prototype.subscriptionsControllerStartFreeTrialV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerStartFreeTrialV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetMySubscriptionV1200Response_1.SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Grants a **10-day free trial** on the plan sheet — backend-only (no RC involvement, no card required).  **One-time enforcement:** the trial can only be started by users where `users.free_trial_used_at IS NULL` **and** `users.paid_purchase_ever_at IS NULL`. Anyone who has ever taken the trial OR paid for any plan is rejected.  Idempotent for an already-active trial — repeated calls while `status=\"trialing\"` return the current state.
     * Start the one-time 10-day free trial
     */
    SubscriptionsApi.prototype.subscriptionsControllerStartFreeTrialV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerStartFreeTrialV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerSwapSportV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerSwapSportV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['swapSportDto'] == null) {
                            throw new runtime.RequiredError('swapSportDto', 'Required parameter "swapSportDto" was null or undefined when calling subscriptionsControllerSwapSportV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/swap-sport";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, SwapSportDto_1.SwapSportDtoToJSON)(requestParameters['swapSportDto']),
                            }];
                }
            });
        });
    };
    /**
     * **Free:** first swap is complimentary (lifetime); then 1 per rolling 365 days. Confirm is client-side — calling this endpoint is the swap. **Champion / trial:** no swap consumption (all sports unlocked).
     * Swap one followed sport for another
     */
    SubscriptionsApi.prototype.subscriptionsControllerSwapSportV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerSwapSportV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerSwapSportV1200Response_1.SubscriptionsControllerSwapSportV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * **Free:** first swap is complimentary (lifetime); then 1 per rolling 365 days. Confirm is client-side — calling this endpoint is the swap. **Champion / trial:** no swap consumption (all sports unlocked).
     * Swap one followed sport for another
     */
    SubscriptionsApi.prototype.subscriptionsControllerSwapSportV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerSwapSportV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerSyncV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerSyncV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/sync";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Mobile calls this after login, after purchase, on app foreground, or when local state seems stale. Backend pulls the canonical customer snapshot from RC and reconciles `user_subscriptions` plus a missing store `payments` row (see the five-rule reconcile in `SubscriptionSyncService`).
     * Force-refresh subscription state from RevenueCat
     */
    SubscriptionsApi.prototype.subscriptionsControllerSyncV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerSyncV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubscriptionsControllerGetMySubscriptionV1200Response_1.SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mobile calls this after login, after purchase, on app foreground, or when local state seems stale. Backend pulls the canonical customer snapshot from RC and reconciles `user_subscriptions` plus a missing store `payments` row (see the five-rule reconcile in `SubscriptionSyncService`).
     * Force-refresh subscription state from RevenueCat
     */
    SubscriptionsApi.prototype.subscriptionsControllerSyncV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerSyncV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for subscriptionsControllerUpdateProSportsV1 without sending the request
     */
    SubscriptionsApi.prototype.subscriptionsControllerUpdateProSportsV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/subscriptions/pro-sports";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Permanently rejected. Pro is not a sellable plan. Use `/swap-sport` or `/me/sports/order`.
     * Retired Pro sport selection
     */
    SubscriptionsApi.prototype.subscriptionsControllerUpdateProSportsV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerUpdateProSportsV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Permanently rejected. Pro is not a sellable plan. Use `/swap-sport` or `/me/sports/order`.
     * Retired Pro sport selection
     */
    SubscriptionsApi.prototype.subscriptionsControllerUpdateProSportsV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsControllerUpdateProSportsV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return SubscriptionsApi;
}(runtime.BaseAPI));
exports.SubscriptionsApi = SubscriptionsApi;
